module.exports = __webpack_public_path__ + "static/media/parvane-arzyabi.c647b4fd.jpeg";